module.exports = __webpack_public_path__ + "img/dingtalk-circle.a42cab41.svg";